import React from 'react';
import { useTranslation } from 'react-i18next';

const leadership = [
  {
    name: 'Smt. R.J. Vidyullatha, IAS',
    designation: 'Director, Town & Country Planning',
    office: 'DTCP Head Office, Mangalagiri',
    icon: 'ri-user-star-line',
  },
];

const regionalOffices = [
  {
    region: 'Visakhapatnam Region',
    officer: 'Joint Director',
    jurisdiction: 'Visakhapatnam, Srikakulam, Vizianagaram, East Godavari, West Godavari districts',
    phone: '0891-2700XXX',
  },
  {
    region: 'Guntur Region',
    officer: 'Joint Director',
    jurisdiction: 'Guntur, Krishna, Prakasam, Nellore, Palnadu, Bapatla districts',
    phone: '0863-2000XXX',
  },
  {
    region: 'Kurnool Region',
    officer: 'Joint Director',
    jurisdiction: 'Kurnool, Anantapur, Nandyal, Sri Sathya Sai districts',
    phone: '08518-2XXXXX',
  },
  {
    region: 'Tirupati Region',
    officer: 'Joint Director',
    jurisdiction: 'Tirupati, Chittoor, Kadapa, Annamayya districts',
    phone: '0877-2XXXXXX',
  },
];

const udas = [
  'Visakhapatnam', 'Vijayawada', 'Guntur', 'Tirupati', 'Rajahmundry',
  'Kakinada', 'Nellore', 'Kurnool', 'Anantapur', 'Eluru',
  'Ongole', 'Kadapa', 'Srikakulam', 'Vizianagaram', 'Tenali',
  'Narasaraopet', 'Proddatur', 'Hindupur', 'Nandyal', 'Mangalagiri',
  'Machilipatnam',
];

export const TeamPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <nav className="flex items-center space-x-2 text-sm text-stone-500 mb-8">
        <a href="/" className="hover:text-amber-700 transition-colors">{t('header.home')}</a>
        <i className="ri-arrow-right-s-line text-stone-400"></i>
        <a href="/about" className="hover:text-amber-700 transition-colors">{t('header.about')}</a>
        <i className="ri-arrow-right-s-line text-stone-400"></i>
        <span className="text-stone-800 font-medium">{t('header.aboutTeam')}</span>
      </nav>

      <div className="mb-12">
        <h1 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4">DTCP Team & Offices</h1>
        <p className="text-lg text-stone-600 max-w-3xl">
          DTCP operates through its head office and 4 regional offices with 21 Urban Development Authorities across Andhra Pradesh.
        </p>
      </div>

      {/* Leadership */}
      <div className="mb-12">
        <h2 className="text-xl font-bold text-stone-800 mb-6 flex items-center">
          <span className="w-1 h-6 bg-amber-600 rounded-full mr-3"></span>
          Leadership
        </h2>
        {leadership.map((leader, index) => (
          <div key={index} className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg p-6 flex items-center space-x-6">
            <div className="w-20 h-20 bg-amber-200 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className={`${leader.icon} w-10 h-10 flex items-center justify-center text-amber-700`}></i>
            </div>
            <div>
              <h3 className="text-lg font-bold text-stone-800">{leader.name}</h3>
              <p className="text-amber-700 font-medium">{leader.designation}</p>
              <p className="text-sm text-stone-600 mt-1">{leader.office}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Regional Offices */}
      <div className="mb-12">
        <h2 className="text-xl font-bold text-stone-800 mb-6 flex items-center">
          <span className="w-1 h-6 bg-amber-600 rounded-full mr-3"></span>
          Regional Offices
        </h2>
        <div className="grid md:grid-cols-2 gap-4">
          {regionalOffices.map((office, index) => (
            <div key={index} className="bg-white border border-stone-200 rounded-lg p-5 hover:shadow-md hover:border-amber-300 transition-all">
              <h3 className="font-semibold text-stone-800 mb-1">{office.region}</h3>
              <p className="text-sm text-amber-700 font-medium mb-2">{office.officer}</p>
              <p className="text-sm text-stone-500 mb-2">{office.jurisdiction}</p>
              <div className="flex items-center space-x-2 text-sm text-stone-600">
                <i className="ri-phone-line text-amber-600"></i>
                <span>{office.phone}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* UDAs */}
      <div>
        <h2 className="text-xl font-bold text-stone-800 mb-6 flex items-center">
          <span className="w-1 h-6 bg-amber-600 rounded-full mr-3"></span>
          Urban Development Authorities (21)
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {udas.map((uda, index) => (
            <div key={index} className="bg-stone-50 border border-stone-200 rounded-lg px-4 py-3 text-center text-sm font-medium text-stone-700 hover:bg-amber-50 hover:border-amber-300 hover:text-amber-700 transition-all cursor-default">
              {uda}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
